import { CoOwnershipMapIcon } from "@/components/Sections/CoOwnership/constants";
export const addIconToCoOwnershipItems = (items) => {
    if (!(items === null || items === void 0 ? void 0 : items.length))
        return [];
    return items.map((item) => (Object.assign(Object.assign({}, item), { icon: CoOwnershipMapIcon[item.type] })));
};
